import { render } from "./ItemsCount.vue?vue&type=template&id=14b6a973&ts=true"
import script from "./ItemsCount.vue?vue&type=script&lang=ts"
export * from "./ItemsCount.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__